<template>
  <transition
    v-if="showModal"
    name="custom-classes-transition"
    enter-active-class="animated bounceInLeft"
    leave-active-class="animated bounceOutRight"
  >
    <div class="detail-modal">
      <div class="detail-modal-inner">
        <div class="menu">
          <div class="close-show-detail" @click="closeModal">
            <eva-icon
              name="close-circle"
              fill="#FFF"
              width="50"
              height="50"
            ></eva-icon>
          </div>
        </div>
        <div class="page-wrap">
          <transition
            name="custom-classes-transition"
            enter-active-class="animated flipInY"
          >
            <perfect-scrollbar class="page">
              <section class="page-inner">
                <form class="demand-form">
                  <div class="tab-content">
                    <div class="tab-section tab-01">
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th colspan="4" class="tab-name">職缺</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td class="width-15 text-right">
                              <span>單號</span>
                            </td>
                            <td class="width-35">
                              {{ demandDetail.No }}
                            </td>
                            <td class="width-15 text-right">
                              <span>狀態</span>
                            </td>
                            <td class="width-35">
                              <span>
                                {{
                                  $common.manpowerDemandStatusFormatter(
                                    demandDetail.ManpowerDemandStatus
                                  )
                                }}
                              </span>
                            </td>
                          </tr>

                          <tr>
                            <td colspan="1" class="text-right">
                              <span>名稱</span>
                            </td>
                            <td colspan="3">
                              {{ demandDetail.ManpowerDemandName }}
                            </td>
                          </tr>

                          <tr>
                            <td class="text-right">
                              <span>申請日期</span>
                            </td>
                            <td>
                              {{
                                $common.dateFormatter(
                                  demandDetail.ApplicantTime
                                )
                              }}
                            </td>
                            <td class="text-right">
                              <span>申請者</span>
                            </td>
                            <td>
                              {{ demandDetail.Applicant }}
                            </td>
                          </tr>

                          <tr>
                            <td colspan="1" class="text-right">
                              <span>申請部門</span>
                            </td>
                            <td colspan="3">
                              {{ demandDetail.DemandDepartment }}
                            </td>
                          </tr>

                          <tr>
                            <td class="text-right">
                              <span>履歷類型</span>
                            </td>
                            <td>
                              <span v-if="demandDetail.ResumeType === 'Main'"
                                >基本履歷</span
                              >
                              <span v-else>{{ demandDetail.ResumeType }}</span>
                            </td>
                            <td class="text-right">
                              <span>招募期限</span>
                            </td>
                            <td>
                              {{
                                $common.dateFormatter(
                                  demandDetail.RecruitmentDeadline
                                )
                              }}
                            </td>
                          </tr>
                          <tr>
                            <td colspan="1" class="text-right">
                              <span>聘僱合約類別</span>
                            </td>
                            <td colspan="3">
                              {{ demandDetail.ContractType }}
                            </td>
                          </tr>

                          <tr>
                            <td colspan="1" class="text-right">
                              <span>招募方式</span>
                            </td>
                            <td colspan="3">
                              <template
                                v-if="
                                  demandDetail.ManpowerDemandRecruitmentMethod
                                    .length > 0
                                "
                              >
                                <span
                                  v-for="item in demandDetail.ManpowerDemandRecruitmentMethod"
                                  :key="item.RecruitmentMethodGuid"
                                >
                                  {{
                                    item.RecruitmentMethodDescription
                                      ? `其他：${item.RecruitmentMethodDescription}`
                                      : item.RecruitmentMethod
                                  }}<br />
                                </span>
                              </template>
                              <template v-else>
                                <span>不拘</span>
                              </template>
                            </td>
                          </tr>

                          <tr>
                            <td class="text-right">
                              <span>職務性質</span>
                            </td>
                            <td>
                              {{ demandDetail.PositionProperty }}
                            </td>
                            <td class="text-right">
                              <span>{{ i18n("Position.PositionName") }}</span>
                            </td>
                            <td>
                              {{ demandDetail.PositionName }}
                            </td>
                          </tr>

                          <tr>
                            <td class="text-right">
                              <span>需求人數</span>
                            </td>
                            <td>{{ demandDetail.DemandNumber }} 人</td>
                            <td class="text-right">
                              <span>預定任職日</span>
                            </td>
                            <td>
                              {{ $common.dateFormatter(demandDetail.OnBoard) }}
                            </td>
                          </tr>

                          <tr>
                            <td class="text-right">
                              <span>年齡</span>
                            </td>
                            <td>
                              <span v-if="demandDetail.AgeRangeWhatever">
                                不拘
                              </span>
                              <span v-else>
                                {{ demandDetail.AgeRangeStart }}～{{
                                  demandDetail.AgeRangeEnd
                                }}
                              </span>
                            </td>
                            <td class="text-right">
                              <span>性別</span>
                            </td>
                            <td>
                              {{ demandDetail.Sex }}
                            </td>
                          </tr>

                          <tr>
                            <td class="text-right">
                              <span>出差</span>
                            </td>
                            <td>
                              {{ !demandDetail.BusinessTrip ? "否" : "是" }}
                            </td>
                            <td class="text-right">
                              <span>外派</span>
                            </td>
                            <td>
                              {{ !demandDetail.OverseasWork ? "否" : "是" }}
                            </td>
                          </tr>

                          <tr>
                            <td colspan="1" class="text-right">
                              <span>管理責任</span>
                            </td>
                            <td colspan="3">
                              <span
                                v-if="demandDetail.ManagementResponsibility"
                              >
                                {{ demandDetail.ManagementNumber }} 人
                              </span>
                              <span v-else>無</span>
                            </td>
                          </tr>

                          <tr>
                            <td colspan="1" class="text-right">
                              <span>輪班</span>
                            </td>
                            <td colspan="3">
                              {{ !demandDetail.Shift ? "否" : "是" }}
                            </td>
                          </tr>

                          <tr>
                            <td colspan="1" class="text-right">
                              <span>班別</span>
                            </td>
                            <td colspan="3">
                              <span v-if="workingHoursStatus">不拘</span>
                              <template v-else>
                                <span
                                  v-for="item in demandDetail.ManpowerDemandWorkShiftType"
                                  :key="item.WorkShiftTypeGuid"
                                >
                                  <strong>{{ item.WorkShiftType }}</strong
                                  >，時段：{{ item.WorkShiftTypeDescription }}
                                  <br />
                                </span>
                              </template>
                            </td>
                          </tr>

                          <tr>
                            <td colspan="1" class="text-right">
                              <span>工作地點</span>
                            </td>
                            <td colspan="3">
                              <span
                                v-for="(item, index) in demandDetail.WorkPlace"
                                :key="index"
                              >
                                <span v-if="index > 0">、</span>{{ item }}
                              </span>
                            </td>
                          </tr>

                          <tr>
                            <td colspan="1" class="text-right">
                              <span>工作內容</span>
                            </td>
                            <td colspan="3">
                              <pre>{{ demandDetail.WorkContent }}</pre>
                            </td>
                          </tr>

                          <tr>
                            <td colspan="1" class="text-right">
                              <span>說明</span>
                            </td>
                            <td colspan="3">
                              <pre>{{ demandDetail.Description }}</pre>
                            </td>
                          </tr>

                          <tr>
                            <td colspan="1" class="text-right">
                              <span>薪資類型</span>
                            </td>
                            <td colspan="3">
                              {{
                                demandDetail.SalaryTypeDescription
                                  ? demandDetail.SalaryTypeDescription
                                  : demandDetail.SalaryType
                              }}
                            </td>
                          </tr>

                          <tr>
                            <td colspan="1" class="text-right">
                              <span>薪資待遇</span>
                            </td>
                            <td colspan="3">
                              {{ demandDetail.SalaryLow }} ~
                              {{ demandDetail.SalaryHigh }}
                            </td>
                          </tr>

                          <tr>
                            <td colspan="1" class="text-right">
                              <span>職務聯絡人</span>
                            </td>
                            <td colspan="3">
                              {{ demandDetail.PositionContactor }}
                            </td>
                          </tr>

                          <tr>
                            <td colspan="1" class="text-right">
                              <span>聯絡人Email</span>
                            </td>
                            <td colspan="3">
                              {{ demandDetail.PositionContactorEmail }}
                            </td>
                          </tr>

                          <tr>
                            <td colspan="1" class="text-right">
                              <span>工作經歷</span>
                            </td>
                            <td colspan="3">
                              <span v-if="demandDetail.WorkExperienceWhatever"
                                >不拘</span
                              >
                              <span v-else
                                >{{ demandDetail.WorkExperience }} 年</span
                              >
                            </td>
                          </tr>

                          <tr>
                            <td colspan="1" class="text-right">
                              <span>學歷</span>
                            </td>
                            <td colspan="3">
                              <span v-if="demandDetail.EducationDemandWhatever">
                                不拘
                              </span>
                              <template v-else>
                                <span
                                  v-for="(
                                    item, index
                                  ) in demandDetail.ManpowerDemandEducationDegree"
                                  :key="item.EducationDegreeGuid"
                                >
                                  <span v-if="index > 0">、</span
                                  >{{ item.EducationDegree }}
                                </span>
                              </template>
                            </td>
                          </tr>

                          <tr>
                            <td colspan="1" class="text-right">
                              <span>科系</span>
                            </td>
                            <td colspan="3">
                              <span
                                v-if="demandDetail.SchoolDepartmentWhatever"
                              >
                                不拘
                              </span>
                              <template v-else>
                                <div
                                  v-for="(
                                    item, index
                                  ) in demandDetail.ManpowerDemandSchoolDepartment"
                                  :key="index"
                                >
                                  <span class="language-title">
                                    {{ item.SchoolDepartmentType }}
                                  </span>
                                  <h6 style="margin-bottom: 12px">
                                    {{
                                      item.SchoolDepartment
                                        ? item.SchoolDepartment
                                        : null
                                    }}
                                    <span
                                      v-if="item.SchoolDepartmentDescription"
                                    >
                                      ｜科系描述：{{
                                        item.SchoolDepartmentDescription
                                      }}
                                    </span>
                                  </h6>
                                </div>
                              </template>
                            </td>
                          </tr>

                          <tr>
                            <td colspan="1" class="text-right">
                              <span>外語</span>
                            </td>
                            <td colspan="3">
                              <span v-if="languageStatus">不拘</span>
                              <template v-else>
                                <div
                                  v-for="(
                                    item, index
                                  ) in demandDetail.ManpowerDemandLanguage"
                                  :key="index"
                                >
                                  <span class="language-title">{{
                                    item.Language
                                  }}</span>
                                  <h6 style="margin-bottom: 12px">
                                    <span class="language-text"
                                      >聽：{{ item.Listen }}</span
                                    >｜
                                    <span class="language-text"
                                      >說：{{ item.Speak }}</span
                                    >｜
                                    <span class="language-text"
                                      >讀：{{ item.Read }}</span
                                    >｜
                                    <span class="language-text"
                                      >寫：{{ item.Write }}</span
                                    >
                                  </h6>
                                </div>
                              </template>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="1" class="text-right">
                              <span>方言</span>
                            </td>
                            <td colspan="3">
                              <span v-if="dialectStatus">不拘</span>
                              <template v-else>
                                <div
                                  v-for="(
                                    item, index
                                  ) in demandDetail.ManpowerDemandDialect"
                                  :key="index"
                                >
                                  <span class="language-title">{{
                                    item.DialectDescription
                                      ? item.DialectDescription
                                      : item.Dialect
                                  }}</span>
                                  <p>程度：{{ item.Degree }}</p>
                                </div>
                              </template>
                            </td>
                          </tr>

                          <tr>
                            <td class="text-right" colspan="1">
                              <span>駕照</span>
                            </td>
                            <td colspan="3">
                              <span v-if="driverLicenseStatus">不拘</span>
                              <template v-else>
                                <span
                                  v-for="(
                                    item, index
                                  ) in demandDetail.ManpowerDemandDriverLicense"
                                  :key="index"
                                >
                                  <span v-if="index > 0">、</span
                                  >{{ item.DriverLicense }}
                                </span>
                              </template>
                            </td>
                          </tr>

                          <tr>
                            <td class="text-right" colspan="1">
                              <span>證照</span>
                            </td>
                            <td colspan="3">
                              <div
                                v-for="category in Object.keys(
                                  showCertifications
                                )"
                                :key="category"
                              >
                                <span class="mr-2">{{ category }}</span>
                                <span
                                  v-for="(item, index) in showCertifications[
                                    category
                                  ]"
                                  :key="index"
                                >
                                  {{
                                    item.CertificateDescription
                                      ? item.CertificateDescription
                                      : item.Certificate
                                  }}
                                  <span
                                    v-if="
                                      index !==
                                      showCertifications[category].length - 1
                                    "
                                    >、</span
                                  >
                                </span>
                                <br />
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td class="text-right" colspan="1">
                              <span>其他條件</span>
                            </td>
                            <td colspan="3">
                              <pre>{{ demandDetail.OtherConditions }}</pre>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </form>
              </section>
            </perfect-scrollbar>
          </transition>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "DemandDetailModal",

  data() {
    return {
      showModal: false,

      driverLicenseStatus: false,
      workingHoursStatus: false,
      languageStatus: false,
      dialectStatus: false,
      demandDetail: [],

      // 證照
      showCertifications: [],
    };
  },

  computed: {
    ...mapGetters(["demandDetailModalNo"]),
  },

  watch: {
    demandDetailModalNo(demandNo) {
      if (demandNo) {
        this.getDemandDetail(demandNo);
      } else {
        this.showModal = false;
      }
    },

    // 薪資待遇(低)
    "demandDetail.SalaryLow": function (newVal) {
      if (newVal) {
        this.demandDetail.SalaryLow = this.$common.currencyThousands(
          String(newVal)
        );
      }
    },

    // 薪資待遇(高)
    "demandDetail.SalaryHigh": function (newVal) {
      if (newVal) {
        this.demandDetail.SalaryHigh = this.$common.currencyThousands(
          String(newVal)
        );
      }
    },
  },

  methods: {
    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },

    closeModal() {
      this.showModal = false;
      this.$store.commit("OpenDemandDetailModal", null);
    },

    getDemandDetail(demandNo) {
      const vm = this;
      const api = `${window.endpoints.api}/ManpowerDemandModule/ByNo/${demandNo}`;

      // 定義本地 groupBy 函數
      function groupBy(array, prop) {
        return array.reduce((groups, item) => {
          const val = item[prop];
          if (!groups[val]) {
            groups[val] = [];
          }
          groups[val].push(item);
          return groups;
        }, {});
      }

      vm.$http
        .get(api)
        .then((response) => {
          if (response.status === 200) {
            vm.demandDetail = response.data;

            // 班別
            vm.workingHoursStatus =
              vm.demandDetail.ManpowerDemandWorkShiftType.length < 1;

            // 外語
            vm.languageStatus =
              vm.demandDetail.ManpowerDemandLanguage.length < 1;

            // 方言
            vm.dialectStatus = vm.demandDetail.ManpowerDemandDialect.length < 1;

            // 駕照
            vm.driverLicenseStatus =
              vm.demandDetail.ManpowerDemandDriverLicense.length < 1;

            // 證照(檢視)分群組
            vm.showCertifications = groupBy(
              vm.demandDetail.ManpowerDemandCertificate,
              "CertificateCategorySecond"
            );

            vm.showModal = true;
          }
        })
        .catch((error) => {
          vm.$notify({
            title: "需求單取得失敗",
            message: error.response.data,
            type: "error",
            duration: 5000,
          });
        });
    },
  },

  destroyed() {
    this.showModal = false;
    this.$store.commit("OpenDemandDetailModal", null);
  },
};
</script>

<style lang="scss" scoped>
.width-15 {
  width: 15%;
}
.width-35 {
  width: 35%;
}
.detail-modal {
  z-index: 2000;
  .detail-modal-inner {
    .menu {
      width: 0%;
    }
    .page-wrap {
      background-image: none;
      .page {
        max-width: 960px;
        margin: 25px auto;
      }
    }
    pre {
      white-space: pre-wrap;
      word-wrap: break-word;
    }
  }
}
</style>
